import md5 from 'md5';

export default {
  methods: {
    getGravatar(email, size = '100') {
      return `https://www.gravatar.com/avatar/${md5(email)}?s=${size}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/avatar.js